import { Checkbox as ChakraCheckbox, CheckboxRootProps } from '@chakra-ui/react/checkbox'
import * as React from 'react'

type CheckboxProps = CheckboxRootProps & {
  inputProps?: React.ComponentProps<typeof ChakraCheckbox.HiddenInput>
  rootRef?: React.Ref<HTMLLabelElement>
  icon?: React.ReactNode
}

export const Checkbox = React.forwardRef(function Checkbox(props: CheckboxProps, ref: React.Ref<HTMLInputElement>) {
  const { icon, children, inputProps, rootRef, ...rest } = props
  return (
    <ChakraCheckbox.Root ref={rootRef} {...rest}>
      <ChakraCheckbox.HiddenInput ref={ref} {...inputProps} />
      <ChakraCheckbox.Control>{icon || <ChakraCheckbox.Indicator />}</ChakraCheckbox.Control>
      {children != null && <ChakraCheckbox.Label>{children}</ChakraCheckbox.Label>}
    </ChakraCheckbox.Root>
  )
})
